var _g, _path, _path2, _path3, _path4, _g2, _g3, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnVerifying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-verifying",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.07,
    height: 71.361,
    viewBox: "0 0 87.07 71.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16161",
    "data-name": "Group 16161",
    transform: "translate(10.703 11.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16881",
    "data-name": "Rectangle 16881",
    fill: "none",
    stroke: "#347cb5",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 60,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.25,
    width: 60.5,
    height: 55.5,
    rx: 5.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1030",
    "data-name": "Line 1030",
    x2: 60.598,
    transform: "translate(1.885 13.775)",
    fill: "none",
    stroke: "#347cb5",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1031",
    "data-name": "Line 1031",
    y2: 12.43,
    transform: "translate(40.73 2.121)",
    fill: "none",
    stroke: "#347cb5",
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1032",
    "data-name": "Line 1032",
    y2: 12.43,
    transform: "translate(52.383 2.121)",
    fill: "none",
    stroke: "#347cb5",
    strokeWidth: 4.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12260",
    "data-name": "Path 12260",
    d: "M389.636,269.97c-2.469-.7-3.557-1.74-3.717-4.151-.161,2.411-1.249,3.448-3.716,4.151,2.468.7,3.556,1.74,3.716,4.151C386.079,271.711,387.168,270.674,389.636,269.97Z",
    transform: "translate(-364.577 -236.344)",
    fill: "#49a9f5",
    opacity: 0.368
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12263",
    "data-name": "Path 12263",
    d: "M389.636,269.97c-2.469-.7-3.557-1.74-3.717-4.151-.161,2.411-1.249,3.448-3.716,4.151,2.468.7,3.556,1.74,3.716,4.151C386.079,271.711,387.168,270.674,389.636,269.97Z",
    transform: "translate(-381.946 -251.547)",
    fill: "#49a9f5",
    opacity: 0.368
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12261",
    "data-name": "Path 12261",
    d: "M379.168,212.847c-2.468-.7-3.556-1.74-3.717-4.151-.161,2.411-1.249,3.448-3.716,4.151,2.467.7,3.555,1.741,3.716,4.151C375.611,214.588,376.7,213.551,379.168,212.847Z",
    transform: "translate(-371.735 -154.975)",
    fill: "#49a9f5",
    opacity: 0.368
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12262",
    "data-name": "Path 12262",
    d: "M409.019,234.691c-1.7-.486-2.456-1.2-2.567-2.868-.111,1.666-.863,2.382-2.567,2.868,1.7.486,2.456,1.2,2.567,2.867C406.563,235.893,407.314,235.177,409.019,234.691Z",
    transform: "translate(-341.169 -175.254)",
    fill: "#49a9f5",
    opacity: 0.368
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16162",
    "data-name": "Group 16162",
    transform: "translate(81.936 26.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M327.218,212.093c-1.7-.486-2.456-1.2-2.567-2.868-.111,1.665-.862,2.382-2.567,2.868,1.7.486,2.456,1.2,2.567,2.867C324.762,213.295,325.514,212.579,327.218,212.093Z",
    transform: "translate(-322.084 -209.225)",
    fill: "#49a9f5",
    opacity: 0.368
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16163",
    "data-name": "Group 16163",
    transform: "translate(38.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739-2",
    "data-name": "Path 739",
    d: "M327.218,212.093c-1.7-.486-2.456-1.2-2.567-2.868-.111,1.665-.862,2.382-2.567,2.868,1.7.486,2.456,1.2,2.567,2.867C324.762,213.295,325.514,212.579,327.218,212.093Z",
    transform: "translate(-322.084 -209.225)",
    fill: "#49a9f5",
    opacity: 0.368
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24447",
    "data-name": "Path 24447",
    d: "M5825.15,588.9l6.507,7.493,14.365-14.311",
    transform: "translate(-5791.315 -542.676)",
    fill: "none",
    stroke: "#00aafc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVerifying);
export default __webpack_public_path__ + "static/media/icn-verifying.c6afbd7f8c934d98cd689afac81359f5.svg";
export { ForwardRef as ReactComponent };